import React from 'react';
import { useParams } from 'react-router-dom';
import { ProductFormShared } from '@/components/products/ProductFormShared';

export function ProductEdit() {
  const { producerId, id } = useParams();

  if (!producerId) {
    return <div className="p-4">Producer ID is required</div>;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6">
        {id ? 'Edit Product' : 'New Product'}
      </h1>
      
      <ProductFormShared 
        productId={id} 
        producerId={producerId}
        isAdmin={true}
      />
    </div>
  );
} 